
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SharedService } from '@app/_services/shared.service';
import { OfferCategoryService } from '@app/_services/offer-category.service';
import { getBedTypeDisplayName } from '@app/model/bed-type-mapping';

@Component({
  selector: 'ui-new-filter-panel',
  standalone: true,
  imports: [],
  templateUrl: './ui-new-filter-panel.component.html',
  styleUrl: './ui-new-filter-panel.component.scss',
})
export class UiNewFilterPanelComponent {
  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;

  @Input() isOpen = false;

  @Input() tags: string[] = [];
  @Input() bedTypes: string[] = [];
  @Input() tagsDict: { [key: string]: { flg_enabled: boolean } } = {};
  @Input() bedTypesDict: { [key: string]: { flg_enabled: boolean } } = {};

  @Input() hasFeaturedOffers = false;
  @Input() featuredOnly = false;

  @Input() hasFavoriteOffers = false;
  @Input() favoriteOnly = false;

  @Output() searchChanged = new EventEmitter<string>();
  @Output() tagClicked = new EventEmitter<string>();
  @Output() bedTypeClicked = new EventEmitter<string>();
  @Output() featuredClicked = new EventEmitter<void>();
  @Output() favoriteClicked = new EventEmitter<void>();

  constructor(
    private sharedService: SharedService,
    private offerCategoryService: OfferCategoryService,
  ) {

  }

  isTagActive(tag: string): boolean {
    return this.tagsDict?.[tag]?.flg_enabled ?? false;
  }

  isBedTypeActive(bedType: string): boolean {
    return this.bedTypesDict?.[bedType]?.flg_enabled ?? false;
  }

  onSearch(value: string) {
    this.searchChanged.emit(value);
  }

  setHighlightsText(): string {
    if(!this.offerCategoryService.isRoomCategory(this.sharedService.activeOfferType)) return 'Highlights';
    return 'View and highlights';
  }

  isRoomOfferType(): boolean {
    return this.offerCategoryService.isRoomCategory(this.sharedService.activeOfferType);
  }

  getBedTypeDisplayName(bedType: string): string {
    return getBedTypeDisplayName(bedType);
  }

  focusSearchInput(): void {
    this.searchInput?.nativeElement?.focus();
  }


}
